module.exports = "<div class=\"kng-panel-overlay\" [ngClass]=\"{show: isOpen()}\" (click)=\"closePanel()\" role=\"button\" tabindex=\"0\"></div>\r\n<div class=\"kng-panel right\" [ngClass]=\"{show: isOpen()}\">\r\n  <ng-content></ng-content>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/dclean-web-latest/cot-web/src/app/layout/kingswell/kng-panel/kng-panel.component.html
// module id = ../../../../../src/app/layout/kingswell/kng-panel/kng-panel.component.html
// module chunks = main